import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import TextInput from '@adsk/alloy-react-text-input';
import { T } from '../../../helpers/i18n';
import { useRfiFormField } from '../../RfiFormProvider';
import { CommonFormField } from '../../../components';
import { ISSUE_ATTRIBUTE_NAMES } from '../../../constants/issue-attribute-names';
import { RfiCreateFormValues } from '../../types';

type CommonTextProps = {
  fieldName: 'title' | 'locationDescription' | 'reference';
  label: string;
};

const CommonText = ({ fieldName, label }: CommonTextProps) => {
  const formik = useFormikContext<RfiCreateFormValues>();
  const { isFieldsMandatory, errorMessage, isSubmitting, fieldRef } = useRfiFormField(fieldName);
  return (
    <CommonFormField
      label={T.translate(label)}
      required={isFieldsMandatory}
      error={errorMessage}
      ref={fieldRef}
    >
      <TextInput
        name={fieldName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values[fieldName]}
        error={!!errorMessage}
        disabled={isSubmitting}
      />
    </CommonFormField>
  );
};

CommonText.propTypes = {
  fieldName: PropTypes.oneOf(Object.values(ISSUE_ATTRIBUTE_NAMES)).isRequired,
  label: PropTypes.string.isRequired,
};

export default CommonText;
